export default {
  subject: "matière",
  email: "e-mail",
  name: "Nom",
  message: "message",
  password: "mot de passe",
  repeatPassword: "Répéter le mot de passe",
  username: "Nom d'utilisateur",
  country: "pays",
  console: "console",
  position: "position",
  newPassword: "nouveau mot de passe",
  passwordConfirmation: "confirmer le nouveau mot de passe",
  title: "titre",
  idOrUsername: "identifiant ou nom d'utilisateur",
  period: "période",
  description: "la description",
  videoCode: "code vidéo",
  order: "commande",
  type: "type",
  teamDowns: "Nombre d'équipes en baisse",
  teamLiguilla: "Nombre d'équipes passant la liguille de l'aile",
  cardNumber: "numéro de carte",
  expirationDate: "date d'expiration",
  cardMonth: "mois",
  cardYear: "année",
}
